/**
 * Generated by orval v7.21.0 🍺
 * Do not edit manually.
 * ScaleFi Nub APIs
 * Scale Fi Apis
 * OpenAPI spec version: v0.0.1
 */
import {
  useInfiniteQuery,
  useMutation,
  useQuery
} from '@tanstack/react-query';
import type {
  DataTag,
  DefinedInitialDataOptions,
  DefinedUseInfiniteQueryResult,
  DefinedUseQueryResult,
  InfiniteData,
  MutationFunction,
  QueryClient,
  QueryFunction,
  QueryKey,
  UndefinedInitialDataOptions,
  UseInfiniteQueryOptions,
  UseInfiniteQueryResult,
  UseMutationOptions,
  UseMutationResult,
  UseQueryOptions,
  UseQueryResult
} from '@tanstack/react-query';

import type {
  NubAccessLevelDTO,
  NubGroupDTO,
  NubPermissionDTO,
  NubUserDTO,
  PasswordChangeRequest,
  SearchByPrimaryGroupParams,
  SearchGroupsParams
} from '../model';

import { customInstance } from '../mutator/custom-instance';



type SecondParameter<T extends (...args: never) => unknown> = Parameters<T>[1];



export const updateUser = (
    userId: string,
    nubUserDTO: NubUserDTO,
 options?: SecondParameter<typeof customInstance>,) => {
      
      
      return customInstance<NubUserDTO>(
      {url: `/api/nub/users/${userId}`, method: 'PUT',
      headers: {'Content-Type': 'application/json', },
      data: nubUserDTO
    },
      options);
    }
  


export const getUpdateUserMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateUser>>, TError,{userId: string;data: NubUserDTO}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof updateUser>>, TError,{userId: string;data: NubUserDTO}, TContext> => {

const mutationKey = ['updateUser'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof updateUser>>, {userId: string;data: NubUserDTO}> = (props) => {
          const {userId,data} = props ?? {};

          return  updateUser(userId,data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type UpdateUserMutationResult = NonNullable<Awaited<ReturnType<typeof updateUser>>>
    export type UpdateUserMutationBody = NubUserDTO
    export type UpdateUserMutationError = unknown

    export const useUpdateUser = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateUser>>, TError,{userId: string;data: NubUserDTO}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof updateUser>>,
        TError,
        {userId: string;data: NubUserDTO},
        TContext
      > => {

      const mutationOptions = getUpdateUserMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    export const resetPassword = (
    userId: string,
 options?: SecondParameter<typeof customInstance>,) => {
      
      
      return customInstance<NubUserDTO>(
      {url: `/api/nub/users/${userId}/reset-password`, method: 'PUT'
    },
      options);
    }
  


export const getResetPasswordMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof resetPassword>>, TError,{userId: string}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof resetPassword>>, TError,{userId: string}, TContext> => {

const mutationKey = ['resetPassword'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof resetPassword>>, {userId: string}> = (props) => {
          const {userId} = props ?? {};

          return  resetPassword(userId,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type ResetPasswordMutationResult = NonNullable<Awaited<ReturnType<typeof resetPassword>>>
    
    export type ResetPasswordMutationError = unknown

    export const useResetPassword = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof resetPassword>>, TError,{userId: string}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof resetPassword>>,
        TError,
        {userId: string},
        TContext
      > => {

      const mutationOptions = getResetPasswordMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    export const changePassword = (
    userId: string,
    passwordChangeRequest: PasswordChangeRequest,
 options?: SecondParameter<typeof customInstance>,) => {
      
      
      return customInstance<NubUserDTO>(
      {url: `/api/nub/users/${userId}/password`, method: 'PUT',
      headers: {'Content-Type': 'application/json', },
      data: passwordChangeRequest
    },
      options);
    }
  


export const getChangePasswordMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof changePassword>>, TError,{userId: string;data: PasswordChangeRequest}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof changePassword>>, TError,{userId: string;data: PasswordChangeRequest}, TContext> => {

const mutationKey = ['changePassword'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof changePassword>>, {userId: string;data: PasswordChangeRequest}> = (props) => {
          const {userId,data} = props ?? {};

          return  changePassword(userId,data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type ChangePasswordMutationResult = NonNullable<Awaited<ReturnType<typeof changePassword>>>
    export type ChangePasswordMutationBody = PasswordChangeRequest
    export type ChangePasswordMutationError = unknown

    export const useChangePassword = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof changePassword>>, TError,{userId: string;data: PasswordChangeRequest}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof changePassword>>,
        TError,
        {userId: string;data: PasswordChangeRequest},
        TContext
      > => {

      const mutationOptions = getChangePasswordMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    export const updateGroup = (
    code: string,
    nubGroupDTO: NubGroupDTO,
 options?: SecondParameter<typeof customInstance>,) => {
      
      
      return customInstance<NubGroupDTO>(
      {url: `/api/nub/groups/${code}`, method: 'PUT',
      headers: {'Content-Type': 'application/json', },
      data: nubGroupDTO
    },
      options);
    }
  


export const getUpdateGroupMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateGroup>>, TError,{code: string;data: NubGroupDTO}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof updateGroup>>, TError,{code: string;data: NubGroupDTO}, TContext> => {

const mutationKey = ['updateGroup'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof updateGroup>>, {code: string;data: NubGroupDTO}> = (props) => {
          const {code,data} = props ?? {};

          return  updateGroup(code,data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type UpdateGroupMutationResult = NonNullable<Awaited<ReturnType<typeof updateGroup>>>
    export type UpdateGroupMutationBody = NubGroupDTO
    export type UpdateGroupMutationError = unknown

    export const useUpdateGroup = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateGroup>>, TError,{code: string;data: NubGroupDTO}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof updateGroup>>,
        TError,
        {code: string;data: NubGroupDTO},
        TContext
      > => {

      const mutationOptions = getUpdateGroupMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    export const updateAccessLevel = (
    code: string,
    nubAccessLevelDTO: NubAccessLevelDTO,
 options?: SecondParameter<typeof customInstance>,) => {
      
      
      return customInstance<NubAccessLevelDTO>(
      {url: `/api/nub/access-levels/${code}`, method: 'PUT',
      headers: {'Content-Type': 'application/json', },
      data: nubAccessLevelDTO
    },
      options);
    }
  


export const getUpdateAccessLevelMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateAccessLevel>>, TError,{code: string;data: NubAccessLevelDTO}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof updateAccessLevel>>, TError,{code: string;data: NubAccessLevelDTO}, TContext> => {

const mutationKey = ['updateAccessLevel'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof updateAccessLevel>>, {code: string;data: NubAccessLevelDTO}> = (props) => {
          const {code,data} = props ?? {};

          return  updateAccessLevel(code,data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type UpdateAccessLevelMutationResult = NonNullable<Awaited<ReturnType<typeof updateAccessLevel>>>
    export type UpdateAccessLevelMutationBody = NubAccessLevelDTO
    export type UpdateAccessLevelMutationError = unknown

    export const useUpdateAccessLevel = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateAccessLevel>>, TError,{code: string;data: NubAccessLevelDTO}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof updateAccessLevel>>,
        TError,
        {code: string;data: NubAccessLevelDTO},
        TContext
      > => {

      const mutationOptions = getUpdateAccessLevelMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    /**
 * Returns maximum 50 records. Use search/filter endpoints to find specific users.
 * @summary Get all users
 */
export const getAllUsers = (
    
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {
      
      
      return customInstance<NubUserDTO[]>(
      {url: `/api/nub/users`, method: 'GET', signal
    },
      options);
    }
  



export const getGetAllUsersInfiniteQueryKey = () => {
    return [
    'infinite', `/api/nub/users`
    ] as const;
    }

export const getGetAllUsersQueryKey = () => {
    return [
    `/api/nub/users`
    ] as const;
    }

    
export const getGetAllUsersInfiniteQueryOptions = <TData = InfiniteData<Awaited<ReturnType<typeof getAllUsers>>>, TError = unknown>( options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getAllUsers>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetAllUsersInfiniteQueryKey();

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getAllUsers>>> = ({ signal }) => getAllUsers(requestOptions, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseInfiniteQueryOptions<Awaited<ReturnType<typeof getAllUsers>>, TError, TData> & { queryKey: DataTag<QueryKey, TData> }
}

export type GetAllUsersInfiniteQueryResult = NonNullable<Awaited<ReturnType<typeof getAllUsers>>>
export type GetAllUsersInfiniteQueryError = unknown


export function useGetAllUsersInfinite<TData = InfiniteData<Awaited<ReturnType<typeof getAllUsers>>>, TError = unknown>(
  options: { query:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getAllUsers>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getAllUsers>>,
          TError,
          Awaited<ReturnType<typeof getAllUsers>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useGetAllUsersInfinite<TData = InfiniteData<Awaited<ReturnType<typeof getAllUsers>>>, TError = unknown>(
  options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getAllUsers>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getAllUsers>>,
          TError,
          Awaited<ReturnType<typeof getAllUsers>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useGetAllUsersInfinite<TData = InfiniteData<Awaited<ReturnType<typeof getAllUsers>>>, TError = unknown>(
  options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getAllUsers>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
/**
 * @summary Get all users
 */

export function useGetAllUsersInfinite<TData = InfiniteData<Awaited<ReturnType<typeof getAllUsers>>>, TError = unknown>(
  options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getAllUsers>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient 
 ):  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {

  const queryOptions = getGetAllUsersInfiniteQueryOptions(options)

  const query = useInfiniteQuery(queryOptions, queryClient) as  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




export const getGetAllUsersQueryOptions = <TData = Awaited<ReturnType<typeof getAllUsers>>, TError = unknown>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAllUsers>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetAllUsersQueryKey();

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getAllUsers>>> = ({ signal }) => getAllUsers(requestOptions, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getAllUsers>>, TError, TData> & { queryKey: DataTag<QueryKey, TData> }
}

export type GetAllUsersQueryResult = NonNullable<Awaited<ReturnType<typeof getAllUsers>>>
export type GetAllUsersQueryError = unknown


export function useGetAllUsers<TData = Awaited<ReturnType<typeof getAllUsers>>, TError = unknown>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAllUsers>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getAllUsers>>,
          TError,
          Awaited<ReturnType<typeof getAllUsers>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useGetAllUsers<TData = Awaited<ReturnType<typeof getAllUsers>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAllUsers>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getAllUsers>>,
          TError,
          Awaited<ReturnType<typeof getAllUsers>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useGetAllUsers<TData = Awaited<ReturnType<typeof getAllUsers>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAllUsers>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
/**
 * @summary Get all users
 */

export function useGetAllUsers<TData = Awaited<ReturnType<typeof getAllUsers>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAllUsers>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {

  const queryOptions = getGetAllUsersQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




export const createUser = (
    nubUserDTO: NubUserDTO,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {
      
      
      return customInstance<NubUserDTO>(
      {url: `/api/nub/users`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: nubUserDTO, signal
    },
      options);
    }
  


export const getCreateUserMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createUser>>, TError,{data: NubUserDTO}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof createUser>>, TError,{data: NubUserDTO}, TContext> => {

const mutationKey = ['createUser'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof createUser>>, {data: NubUserDTO}> = (props) => {
          const {data} = props ?? {};

          return  createUser(data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type CreateUserMutationResult = NonNullable<Awaited<ReturnType<typeof createUser>>>
    export type CreateUserMutationBody = NubUserDTO
    export type CreateUserMutationError = unknown

    export const useCreateUser = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createUser>>, TError,{data: NubUserDTO}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof createUser>>,
        TError,
        {data: NubUserDTO},
        TContext
      > => {

      const mutationOptions = getCreateUserMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    export const getAllGroups = (
    
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {
      
      
      return customInstance<NubGroupDTO[]>(
      {url: `/api/nub/groups`, method: 'GET', signal
    },
      options);
    }
  



export const getGetAllGroupsInfiniteQueryKey = () => {
    return [
    'infinite', `/api/nub/groups`
    ] as const;
    }

export const getGetAllGroupsQueryKey = () => {
    return [
    `/api/nub/groups`
    ] as const;
    }

    
export const getGetAllGroupsInfiniteQueryOptions = <TData = InfiniteData<Awaited<ReturnType<typeof getAllGroups>>>, TError = unknown>( options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getAllGroups>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetAllGroupsInfiniteQueryKey();

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getAllGroups>>> = ({ signal }) => getAllGroups(requestOptions, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseInfiniteQueryOptions<Awaited<ReturnType<typeof getAllGroups>>, TError, TData> & { queryKey: DataTag<QueryKey, TData> }
}

export type GetAllGroupsInfiniteQueryResult = NonNullable<Awaited<ReturnType<typeof getAllGroups>>>
export type GetAllGroupsInfiniteQueryError = unknown


export function useGetAllGroupsInfinite<TData = InfiniteData<Awaited<ReturnType<typeof getAllGroups>>>, TError = unknown>(
  options: { query:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getAllGroups>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getAllGroups>>,
          TError,
          Awaited<ReturnType<typeof getAllGroups>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useGetAllGroupsInfinite<TData = InfiniteData<Awaited<ReturnType<typeof getAllGroups>>>, TError = unknown>(
  options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getAllGroups>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getAllGroups>>,
          TError,
          Awaited<ReturnType<typeof getAllGroups>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useGetAllGroupsInfinite<TData = InfiniteData<Awaited<ReturnType<typeof getAllGroups>>>, TError = unknown>(
  options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getAllGroups>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }

export function useGetAllGroupsInfinite<TData = InfiniteData<Awaited<ReturnType<typeof getAllGroups>>>, TError = unknown>(
  options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getAllGroups>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient 
 ):  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {

  const queryOptions = getGetAllGroupsInfiniteQueryOptions(options)

  const query = useInfiniteQuery(queryOptions, queryClient) as  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




export const getGetAllGroupsQueryOptions = <TData = Awaited<ReturnType<typeof getAllGroups>>, TError = unknown>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAllGroups>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetAllGroupsQueryKey();

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getAllGroups>>> = ({ signal }) => getAllGroups(requestOptions, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getAllGroups>>, TError, TData> & { queryKey: DataTag<QueryKey, TData> }
}

export type GetAllGroupsQueryResult = NonNullable<Awaited<ReturnType<typeof getAllGroups>>>
export type GetAllGroupsQueryError = unknown


export function useGetAllGroups<TData = Awaited<ReturnType<typeof getAllGroups>>, TError = unknown>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAllGroups>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getAllGroups>>,
          TError,
          Awaited<ReturnType<typeof getAllGroups>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useGetAllGroups<TData = Awaited<ReturnType<typeof getAllGroups>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAllGroups>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getAllGroups>>,
          TError,
          Awaited<ReturnType<typeof getAllGroups>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useGetAllGroups<TData = Awaited<ReturnType<typeof getAllGroups>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAllGroups>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }

export function useGetAllGroups<TData = Awaited<ReturnType<typeof getAllGroups>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAllGroups>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {

  const queryOptions = getGetAllGroupsQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




export const createGroup = (
    nubGroupDTO: NubGroupDTO,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {
      
      
      return customInstance<NubGroupDTO>(
      {url: `/api/nub/groups`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: nubGroupDTO, signal
    },
      options);
    }
  


export const getCreateGroupMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createGroup>>, TError,{data: NubGroupDTO}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof createGroup>>, TError,{data: NubGroupDTO}, TContext> => {

const mutationKey = ['createGroup'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof createGroup>>, {data: NubGroupDTO}> = (props) => {
          const {data} = props ?? {};

          return  createGroup(data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type CreateGroupMutationResult = NonNullable<Awaited<ReturnType<typeof createGroup>>>
    export type CreateGroupMutationBody = NubGroupDTO
    export type CreateGroupMutationError = unknown

    export const useCreateGroup = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createGroup>>, TError,{data: NubGroupDTO}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof createGroup>>,
        TError,
        {data: NubGroupDTO},
        TContext
      > => {

      const mutationOptions = getCreateGroupMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    export const getAllAccessLevels = (
    
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {
      
      
      return customInstance<NubAccessLevelDTO[]>(
      {url: `/api/nub/access-levels`, method: 'GET', signal
    },
      options);
    }
  



export const getGetAllAccessLevelsInfiniteQueryKey = () => {
    return [
    'infinite', `/api/nub/access-levels`
    ] as const;
    }

export const getGetAllAccessLevelsQueryKey = () => {
    return [
    `/api/nub/access-levels`
    ] as const;
    }

    
export const getGetAllAccessLevelsInfiniteQueryOptions = <TData = InfiniteData<Awaited<ReturnType<typeof getAllAccessLevels>>>, TError = unknown>( options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getAllAccessLevels>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetAllAccessLevelsInfiniteQueryKey();

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getAllAccessLevels>>> = ({ signal }) => getAllAccessLevels(requestOptions, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseInfiniteQueryOptions<Awaited<ReturnType<typeof getAllAccessLevels>>, TError, TData> & { queryKey: DataTag<QueryKey, TData> }
}

export type GetAllAccessLevelsInfiniteQueryResult = NonNullable<Awaited<ReturnType<typeof getAllAccessLevels>>>
export type GetAllAccessLevelsInfiniteQueryError = unknown


export function useGetAllAccessLevelsInfinite<TData = InfiniteData<Awaited<ReturnType<typeof getAllAccessLevels>>>, TError = unknown>(
  options: { query:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getAllAccessLevels>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getAllAccessLevels>>,
          TError,
          Awaited<ReturnType<typeof getAllAccessLevels>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useGetAllAccessLevelsInfinite<TData = InfiniteData<Awaited<ReturnType<typeof getAllAccessLevels>>>, TError = unknown>(
  options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getAllAccessLevels>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getAllAccessLevels>>,
          TError,
          Awaited<ReturnType<typeof getAllAccessLevels>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useGetAllAccessLevelsInfinite<TData = InfiniteData<Awaited<ReturnType<typeof getAllAccessLevels>>>, TError = unknown>(
  options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getAllAccessLevels>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }

export function useGetAllAccessLevelsInfinite<TData = InfiniteData<Awaited<ReturnType<typeof getAllAccessLevels>>>, TError = unknown>(
  options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getAllAccessLevels>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient 
 ):  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {

  const queryOptions = getGetAllAccessLevelsInfiniteQueryOptions(options)

  const query = useInfiniteQuery(queryOptions, queryClient) as  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




export const getGetAllAccessLevelsQueryOptions = <TData = Awaited<ReturnType<typeof getAllAccessLevels>>, TError = unknown>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAllAccessLevels>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetAllAccessLevelsQueryKey();

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getAllAccessLevels>>> = ({ signal }) => getAllAccessLevels(requestOptions, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getAllAccessLevels>>, TError, TData> & { queryKey: DataTag<QueryKey, TData> }
}

export type GetAllAccessLevelsQueryResult = NonNullable<Awaited<ReturnType<typeof getAllAccessLevels>>>
export type GetAllAccessLevelsQueryError = unknown


export function useGetAllAccessLevels<TData = Awaited<ReturnType<typeof getAllAccessLevels>>, TError = unknown>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAllAccessLevels>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getAllAccessLevels>>,
          TError,
          Awaited<ReturnType<typeof getAllAccessLevels>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useGetAllAccessLevels<TData = Awaited<ReturnType<typeof getAllAccessLevels>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAllAccessLevels>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getAllAccessLevels>>,
          TError,
          Awaited<ReturnType<typeof getAllAccessLevels>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useGetAllAccessLevels<TData = Awaited<ReturnType<typeof getAllAccessLevels>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAllAccessLevels>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }

export function useGetAllAccessLevels<TData = Awaited<ReturnType<typeof getAllAccessLevels>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAllAccessLevels>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {

  const queryOptions = getGetAllAccessLevelsQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




export const createAccessLevel = (
    nubAccessLevelDTO: NubAccessLevelDTO,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {
      
      
      return customInstance<NubAccessLevelDTO>(
      {url: `/api/nub/access-levels`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: nubAccessLevelDTO, signal
    },
      options);
    }
  


export const getCreateAccessLevelMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createAccessLevel>>, TError,{data: NubAccessLevelDTO}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof createAccessLevel>>, TError,{data: NubAccessLevelDTO}, TContext> => {

const mutationKey = ['createAccessLevel'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof createAccessLevel>>, {data: NubAccessLevelDTO}> = (props) => {
          const {data} = props ?? {};

          return  createAccessLevel(data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type CreateAccessLevelMutationResult = NonNullable<Awaited<ReturnType<typeof createAccessLevel>>>
    export type CreateAccessLevelMutationBody = NubAccessLevelDTO
    export type CreateAccessLevelMutationError = unknown

    export const useCreateAccessLevel = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createAccessLevel>>, TError,{data: NubAccessLevelDTO}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof createAccessLevel>>,
        TError,
        {data: NubAccessLevelDTO},
        TContext
      > => {

      const mutationOptions = getCreateAccessLevelMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    /**
 * Returns maximum 50 records. Use filters to narrow down results.
 * @summary Search users by field
 */
export const searchUserByField = (
    field: string,
    value: string,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {
      
      
      return customInstance<NubUserDTO[]>(
      {url: `/api/nub/users/search/${field}/${value}`, method: 'GET', signal
    },
      options);
    }
  



export const getSearchUserByFieldInfiniteQueryKey = (field?: string,
    value?: string,) => {
    return [
    'infinite', `/api/nub/users/search/${field}/${value}`
    ] as const;
    }

export const getSearchUserByFieldQueryKey = (field?: string,
    value?: string,) => {
    return [
    `/api/nub/users/search/${field}/${value}`
    ] as const;
    }

    
export const getSearchUserByFieldInfiniteQueryOptions = <TData = InfiniteData<Awaited<ReturnType<typeof searchUserByField>>>, TError = unknown>(field: string,
    value: string, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof searchUserByField>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getSearchUserByFieldInfiniteQueryKey(field,value);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof searchUserByField>>> = ({ signal }) => searchUserByField(field,value, requestOptions, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(field && value), ...queryOptions} as UseInfiniteQueryOptions<Awaited<ReturnType<typeof searchUserByField>>, TError, TData> & { queryKey: DataTag<QueryKey, TData> }
}

export type SearchUserByFieldInfiniteQueryResult = NonNullable<Awaited<ReturnType<typeof searchUserByField>>>
export type SearchUserByFieldInfiniteQueryError = unknown


export function useSearchUserByFieldInfinite<TData = InfiniteData<Awaited<ReturnType<typeof searchUserByField>>>, TError = unknown>(
 field: string,
    value: string, options: { query:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof searchUserByField>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof searchUserByField>>,
          TError,
          Awaited<ReturnType<typeof searchUserByField>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useSearchUserByFieldInfinite<TData = InfiniteData<Awaited<ReturnType<typeof searchUserByField>>>, TError = unknown>(
 field: string,
    value: string, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof searchUserByField>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof searchUserByField>>,
          TError,
          Awaited<ReturnType<typeof searchUserByField>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useSearchUserByFieldInfinite<TData = InfiniteData<Awaited<ReturnType<typeof searchUserByField>>>, TError = unknown>(
 field: string,
    value: string, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof searchUserByField>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
/**
 * @summary Search users by field
 */

export function useSearchUserByFieldInfinite<TData = InfiniteData<Awaited<ReturnType<typeof searchUserByField>>>, TError = unknown>(
 field: string,
    value: string, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof searchUserByField>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient 
 ):  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {

  const queryOptions = getSearchUserByFieldInfiniteQueryOptions(field,value,options)

  const query = useInfiniteQuery(queryOptions, queryClient) as  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




export const getSearchUserByFieldQueryOptions = <TData = Awaited<ReturnType<typeof searchUserByField>>, TError = unknown>(field: string,
    value: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof searchUserByField>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getSearchUserByFieldQueryKey(field,value);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof searchUserByField>>> = ({ signal }) => searchUserByField(field,value, requestOptions, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(field && value), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof searchUserByField>>, TError, TData> & { queryKey: DataTag<QueryKey, TData> }
}

export type SearchUserByFieldQueryResult = NonNullable<Awaited<ReturnType<typeof searchUserByField>>>
export type SearchUserByFieldQueryError = unknown


export function useSearchUserByField<TData = Awaited<ReturnType<typeof searchUserByField>>, TError = unknown>(
 field: string,
    value: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof searchUserByField>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof searchUserByField>>,
          TError,
          Awaited<ReturnType<typeof searchUserByField>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useSearchUserByField<TData = Awaited<ReturnType<typeof searchUserByField>>, TError = unknown>(
 field: string,
    value: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof searchUserByField>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof searchUserByField>>,
          TError,
          Awaited<ReturnType<typeof searchUserByField>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useSearchUserByField<TData = Awaited<ReturnType<typeof searchUserByField>>, TError = unknown>(
 field: string,
    value: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof searchUserByField>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
/**
 * @summary Search users by field
 */

export function useSearchUserByField<TData = Awaited<ReturnType<typeof searchUserByField>>, TError = unknown>(
 field: string,
    value: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof searchUserByField>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {

  const queryOptions = getSearchUserByFieldQueryOptions(field,value,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * Returns maximum 50 records. Use filters to narrow down results.
 * @summary Search users by primary group and name
 */
export const searchByPrimaryGroupAndFullName = (
    primaryGroupCode: string,
    name: string,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {
      
      
      return customInstance<NubUserDTO[]>(
      {url: `/api/nub/users/search-by-primary-group-and-name/${primaryGroupCode}/${name}`, method: 'GET', signal
    },
      options);
    }
  



export const getSearchByPrimaryGroupAndFullNameInfiniteQueryKey = (primaryGroupCode?: string,
    name?: string,) => {
    return [
    'infinite', `/api/nub/users/search-by-primary-group-and-name/${primaryGroupCode}/${name}`
    ] as const;
    }

export const getSearchByPrimaryGroupAndFullNameQueryKey = (primaryGroupCode?: string,
    name?: string,) => {
    return [
    `/api/nub/users/search-by-primary-group-and-name/${primaryGroupCode}/${name}`
    ] as const;
    }

    
export const getSearchByPrimaryGroupAndFullNameInfiniteQueryOptions = <TData = InfiniteData<Awaited<ReturnType<typeof searchByPrimaryGroupAndFullName>>>, TError = unknown>(primaryGroupCode: string,
    name: string, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof searchByPrimaryGroupAndFullName>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getSearchByPrimaryGroupAndFullNameInfiniteQueryKey(primaryGroupCode,name);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof searchByPrimaryGroupAndFullName>>> = ({ signal }) => searchByPrimaryGroupAndFullName(primaryGroupCode,name, requestOptions, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(primaryGroupCode && name), ...queryOptions} as UseInfiniteQueryOptions<Awaited<ReturnType<typeof searchByPrimaryGroupAndFullName>>, TError, TData> & { queryKey: DataTag<QueryKey, TData> }
}

export type SearchByPrimaryGroupAndFullNameInfiniteQueryResult = NonNullable<Awaited<ReturnType<typeof searchByPrimaryGroupAndFullName>>>
export type SearchByPrimaryGroupAndFullNameInfiniteQueryError = unknown


export function useSearchByPrimaryGroupAndFullNameInfinite<TData = InfiniteData<Awaited<ReturnType<typeof searchByPrimaryGroupAndFullName>>>, TError = unknown>(
 primaryGroupCode: string,
    name: string, options: { query:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof searchByPrimaryGroupAndFullName>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof searchByPrimaryGroupAndFullName>>,
          TError,
          Awaited<ReturnType<typeof searchByPrimaryGroupAndFullName>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useSearchByPrimaryGroupAndFullNameInfinite<TData = InfiniteData<Awaited<ReturnType<typeof searchByPrimaryGroupAndFullName>>>, TError = unknown>(
 primaryGroupCode: string,
    name: string, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof searchByPrimaryGroupAndFullName>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof searchByPrimaryGroupAndFullName>>,
          TError,
          Awaited<ReturnType<typeof searchByPrimaryGroupAndFullName>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useSearchByPrimaryGroupAndFullNameInfinite<TData = InfiniteData<Awaited<ReturnType<typeof searchByPrimaryGroupAndFullName>>>, TError = unknown>(
 primaryGroupCode: string,
    name: string, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof searchByPrimaryGroupAndFullName>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
/**
 * @summary Search users by primary group and name
 */

export function useSearchByPrimaryGroupAndFullNameInfinite<TData = InfiniteData<Awaited<ReturnType<typeof searchByPrimaryGroupAndFullName>>>, TError = unknown>(
 primaryGroupCode: string,
    name: string, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof searchByPrimaryGroupAndFullName>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient 
 ):  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {

  const queryOptions = getSearchByPrimaryGroupAndFullNameInfiniteQueryOptions(primaryGroupCode,name,options)

  const query = useInfiniteQuery(queryOptions, queryClient) as  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




export const getSearchByPrimaryGroupAndFullNameQueryOptions = <TData = Awaited<ReturnType<typeof searchByPrimaryGroupAndFullName>>, TError = unknown>(primaryGroupCode: string,
    name: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof searchByPrimaryGroupAndFullName>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getSearchByPrimaryGroupAndFullNameQueryKey(primaryGroupCode,name);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof searchByPrimaryGroupAndFullName>>> = ({ signal }) => searchByPrimaryGroupAndFullName(primaryGroupCode,name, requestOptions, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(primaryGroupCode && name), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof searchByPrimaryGroupAndFullName>>, TError, TData> & { queryKey: DataTag<QueryKey, TData> }
}

export type SearchByPrimaryGroupAndFullNameQueryResult = NonNullable<Awaited<ReturnType<typeof searchByPrimaryGroupAndFullName>>>
export type SearchByPrimaryGroupAndFullNameQueryError = unknown


export function useSearchByPrimaryGroupAndFullName<TData = Awaited<ReturnType<typeof searchByPrimaryGroupAndFullName>>, TError = unknown>(
 primaryGroupCode: string,
    name: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof searchByPrimaryGroupAndFullName>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof searchByPrimaryGroupAndFullName>>,
          TError,
          Awaited<ReturnType<typeof searchByPrimaryGroupAndFullName>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useSearchByPrimaryGroupAndFullName<TData = Awaited<ReturnType<typeof searchByPrimaryGroupAndFullName>>, TError = unknown>(
 primaryGroupCode: string,
    name: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof searchByPrimaryGroupAndFullName>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof searchByPrimaryGroupAndFullName>>,
          TError,
          Awaited<ReturnType<typeof searchByPrimaryGroupAndFullName>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useSearchByPrimaryGroupAndFullName<TData = Awaited<ReturnType<typeof searchByPrimaryGroupAndFullName>>, TError = unknown>(
 primaryGroupCode: string,
    name: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof searchByPrimaryGroupAndFullName>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
/**
 * @summary Search users by primary group and name
 */

export function useSearchByPrimaryGroupAndFullName<TData = Awaited<ReturnType<typeof searchByPrimaryGroupAndFullName>>, TError = unknown>(
 primaryGroupCode: string,
    name: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof searchByPrimaryGroupAndFullName>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {

  const queryOptions = getSearchByPrimaryGroupAndFullNameQueryOptions(primaryGroupCode,name,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * Returns maximum 50 records. Use filters to narrow down results.
 * @summary Get users by institution
 */
export const getUsersByInstitution = (
    institutionId: string,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {
      
      
      return customInstance<NubUserDTO[]>(
      {url: `/api/nub/users/institution/${institutionId}`, method: 'GET', signal
    },
      options);
    }
  



export const getGetUsersByInstitutionInfiniteQueryKey = (institutionId?: string,) => {
    return [
    'infinite', `/api/nub/users/institution/${institutionId}`
    ] as const;
    }

export const getGetUsersByInstitutionQueryKey = (institutionId?: string,) => {
    return [
    `/api/nub/users/institution/${institutionId}`
    ] as const;
    }

    
export const getGetUsersByInstitutionInfiniteQueryOptions = <TData = InfiniteData<Awaited<ReturnType<typeof getUsersByInstitution>>>, TError = unknown>(institutionId: string, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getUsersByInstitution>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetUsersByInstitutionInfiniteQueryKey(institutionId);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getUsersByInstitution>>> = ({ signal }) => getUsersByInstitution(institutionId, requestOptions, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(institutionId), ...queryOptions} as UseInfiniteQueryOptions<Awaited<ReturnType<typeof getUsersByInstitution>>, TError, TData> & { queryKey: DataTag<QueryKey, TData> }
}

export type GetUsersByInstitutionInfiniteQueryResult = NonNullable<Awaited<ReturnType<typeof getUsersByInstitution>>>
export type GetUsersByInstitutionInfiniteQueryError = unknown


export function useGetUsersByInstitutionInfinite<TData = InfiniteData<Awaited<ReturnType<typeof getUsersByInstitution>>>, TError = unknown>(
 institutionId: string, options: { query:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getUsersByInstitution>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getUsersByInstitution>>,
          TError,
          Awaited<ReturnType<typeof getUsersByInstitution>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useGetUsersByInstitutionInfinite<TData = InfiniteData<Awaited<ReturnType<typeof getUsersByInstitution>>>, TError = unknown>(
 institutionId: string, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getUsersByInstitution>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getUsersByInstitution>>,
          TError,
          Awaited<ReturnType<typeof getUsersByInstitution>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useGetUsersByInstitutionInfinite<TData = InfiniteData<Awaited<ReturnType<typeof getUsersByInstitution>>>, TError = unknown>(
 institutionId: string, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getUsersByInstitution>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
/**
 * @summary Get users by institution
 */

export function useGetUsersByInstitutionInfinite<TData = InfiniteData<Awaited<ReturnType<typeof getUsersByInstitution>>>, TError = unknown>(
 institutionId: string, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getUsersByInstitution>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient 
 ):  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {

  const queryOptions = getGetUsersByInstitutionInfiniteQueryOptions(institutionId,options)

  const query = useInfiniteQuery(queryOptions, queryClient) as  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




export const getGetUsersByInstitutionQueryOptions = <TData = Awaited<ReturnType<typeof getUsersByInstitution>>, TError = unknown>(institutionId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getUsersByInstitution>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetUsersByInstitutionQueryKey(institutionId);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getUsersByInstitution>>> = ({ signal }) => getUsersByInstitution(institutionId, requestOptions, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(institutionId), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getUsersByInstitution>>, TError, TData> & { queryKey: DataTag<QueryKey, TData> }
}

export type GetUsersByInstitutionQueryResult = NonNullable<Awaited<ReturnType<typeof getUsersByInstitution>>>
export type GetUsersByInstitutionQueryError = unknown


export function useGetUsersByInstitution<TData = Awaited<ReturnType<typeof getUsersByInstitution>>, TError = unknown>(
 institutionId: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getUsersByInstitution>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getUsersByInstitution>>,
          TError,
          Awaited<ReturnType<typeof getUsersByInstitution>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useGetUsersByInstitution<TData = Awaited<ReturnType<typeof getUsersByInstitution>>, TError = unknown>(
 institutionId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getUsersByInstitution>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getUsersByInstitution>>,
          TError,
          Awaited<ReturnType<typeof getUsersByInstitution>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useGetUsersByInstitution<TData = Awaited<ReturnType<typeof getUsersByInstitution>>, TError = unknown>(
 institutionId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getUsersByInstitution>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
/**
 * @summary Get users by institution
 */

export function useGetUsersByInstitution<TData = Awaited<ReturnType<typeof getUsersByInstitution>>, TError = unknown>(
 institutionId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getUsersByInstitution>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {

  const queryOptions = getGetUsersByInstitutionQueryOptions(institutionId,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * Returns users by primary group code. Optional name parameter filters results. Returns maximum 50 records.
 * @summary Search users by primary group with optional name filter
 */
export const searchByPrimaryGroup = (
    params: SearchByPrimaryGroupParams,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {
      
      
      return customInstance<NubUserDTO[]>(
      {url: `/api/nub/users/by-group`, method: 'GET',
        params, signal
    },
      options);
    }
  



export const getSearchByPrimaryGroupInfiniteQueryKey = (params?: SearchByPrimaryGroupParams,) => {
    return [
    'infinite', `/api/nub/users/by-group`, ...(params ? [params]: [])
    ] as const;
    }

export const getSearchByPrimaryGroupQueryKey = (params?: SearchByPrimaryGroupParams,) => {
    return [
    `/api/nub/users/by-group`, ...(params ? [params]: [])
    ] as const;
    }

    
export const getSearchByPrimaryGroupInfiniteQueryOptions = <TData = InfiniteData<Awaited<ReturnType<typeof searchByPrimaryGroup>>>, TError = unknown>(params: SearchByPrimaryGroupParams, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof searchByPrimaryGroup>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getSearchByPrimaryGroupInfiniteQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof searchByPrimaryGroup>>> = ({ signal }) => searchByPrimaryGroup(params, requestOptions, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseInfiniteQueryOptions<Awaited<ReturnType<typeof searchByPrimaryGroup>>, TError, TData> & { queryKey: DataTag<QueryKey, TData> }
}

export type SearchByPrimaryGroupInfiniteQueryResult = NonNullable<Awaited<ReturnType<typeof searchByPrimaryGroup>>>
export type SearchByPrimaryGroupInfiniteQueryError = unknown


export function useSearchByPrimaryGroupInfinite<TData = InfiniteData<Awaited<ReturnType<typeof searchByPrimaryGroup>>>, TError = unknown>(
 params: SearchByPrimaryGroupParams, options: { query:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof searchByPrimaryGroup>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof searchByPrimaryGroup>>,
          TError,
          Awaited<ReturnType<typeof searchByPrimaryGroup>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useSearchByPrimaryGroupInfinite<TData = InfiniteData<Awaited<ReturnType<typeof searchByPrimaryGroup>>>, TError = unknown>(
 params: SearchByPrimaryGroupParams, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof searchByPrimaryGroup>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof searchByPrimaryGroup>>,
          TError,
          Awaited<ReturnType<typeof searchByPrimaryGroup>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useSearchByPrimaryGroupInfinite<TData = InfiniteData<Awaited<ReturnType<typeof searchByPrimaryGroup>>>, TError = unknown>(
 params: SearchByPrimaryGroupParams, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof searchByPrimaryGroup>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
/**
 * @summary Search users by primary group with optional name filter
 */

export function useSearchByPrimaryGroupInfinite<TData = InfiniteData<Awaited<ReturnType<typeof searchByPrimaryGroup>>>, TError = unknown>(
 params: SearchByPrimaryGroupParams, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof searchByPrimaryGroup>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient 
 ):  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {

  const queryOptions = getSearchByPrimaryGroupInfiniteQueryOptions(params,options)

  const query = useInfiniteQuery(queryOptions, queryClient) as  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




export const getSearchByPrimaryGroupQueryOptions = <TData = Awaited<ReturnType<typeof searchByPrimaryGroup>>, TError = unknown>(params: SearchByPrimaryGroupParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof searchByPrimaryGroup>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getSearchByPrimaryGroupQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof searchByPrimaryGroup>>> = ({ signal }) => searchByPrimaryGroup(params, requestOptions, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof searchByPrimaryGroup>>, TError, TData> & { queryKey: DataTag<QueryKey, TData> }
}

export type SearchByPrimaryGroupQueryResult = NonNullable<Awaited<ReturnType<typeof searchByPrimaryGroup>>>
export type SearchByPrimaryGroupQueryError = unknown


export function useSearchByPrimaryGroup<TData = Awaited<ReturnType<typeof searchByPrimaryGroup>>, TError = unknown>(
 params: SearchByPrimaryGroupParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof searchByPrimaryGroup>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof searchByPrimaryGroup>>,
          TError,
          Awaited<ReturnType<typeof searchByPrimaryGroup>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useSearchByPrimaryGroup<TData = Awaited<ReturnType<typeof searchByPrimaryGroup>>, TError = unknown>(
 params: SearchByPrimaryGroupParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof searchByPrimaryGroup>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof searchByPrimaryGroup>>,
          TError,
          Awaited<ReturnType<typeof searchByPrimaryGroup>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useSearchByPrimaryGroup<TData = Awaited<ReturnType<typeof searchByPrimaryGroup>>, TError = unknown>(
 params: SearchByPrimaryGroupParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof searchByPrimaryGroup>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
/**
 * @summary Search users by primary group with optional name filter
 */

export function useSearchByPrimaryGroup<TData = Awaited<ReturnType<typeof searchByPrimaryGroup>>, TError = unknown>(
 params: SearchByPrimaryGroupParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof searchByPrimaryGroup>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {

  const queryOptions = getSearchByPrimaryGroupQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




export const getAllPermissions = (
    
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {
      
      
      return customInstance<NubPermissionDTO[]>(
      {url: `/api/nub/permissions`, method: 'GET', signal
    },
      options);
    }
  



export const getGetAllPermissionsInfiniteQueryKey = () => {
    return [
    'infinite', `/api/nub/permissions`
    ] as const;
    }

export const getGetAllPermissionsQueryKey = () => {
    return [
    `/api/nub/permissions`
    ] as const;
    }

    
export const getGetAllPermissionsInfiniteQueryOptions = <TData = InfiniteData<Awaited<ReturnType<typeof getAllPermissions>>>, TError = unknown>( options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getAllPermissions>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetAllPermissionsInfiniteQueryKey();

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getAllPermissions>>> = ({ signal }) => getAllPermissions(requestOptions, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseInfiniteQueryOptions<Awaited<ReturnType<typeof getAllPermissions>>, TError, TData> & { queryKey: DataTag<QueryKey, TData> }
}

export type GetAllPermissionsInfiniteQueryResult = NonNullable<Awaited<ReturnType<typeof getAllPermissions>>>
export type GetAllPermissionsInfiniteQueryError = unknown


export function useGetAllPermissionsInfinite<TData = InfiniteData<Awaited<ReturnType<typeof getAllPermissions>>>, TError = unknown>(
  options: { query:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getAllPermissions>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getAllPermissions>>,
          TError,
          Awaited<ReturnType<typeof getAllPermissions>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useGetAllPermissionsInfinite<TData = InfiniteData<Awaited<ReturnType<typeof getAllPermissions>>>, TError = unknown>(
  options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getAllPermissions>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getAllPermissions>>,
          TError,
          Awaited<ReturnType<typeof getAllPermissions>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useGetAllPermissionsInfinite<TData = InfiniteData<Awaited<ReturnType<typeof getAllPermissions>>>, TError = unknown>(
  options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getAllPermissions>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }

export function useGetAllPermissionsInfinite<TData = InfiniteData<Awaited<ReturnType<typeof getAllPermissions>>>, TError = unknown>(
  options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getAllPermissions>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient 
 ):  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {

  const queryOptions = getGetAllPermissionsInfiniteQueryOptions(options)

  const query = useInfiniteQuery(queryOptions, queryClient) as  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




export const getGetAllPermissionsQueryOptions = <TData = Awaited<ReturnType<typeof getAllPermissions>>, TError = unknown>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAllPermissions>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetAllPermissionsQueryKey();

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getAllPermissions>>> = ({ signal }) => getAllPermissions(requestOptions, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getAllPermissions>>, TError, TData> & { queryKey: DataTag<QueryKey, TData> }
}

export type GetAllPermissionsQueryResult = NonNullable<Awaited<ReturnType<typeof getAllPermissions>>>
export type GetAllPermissionsQueryError = unknown


export function useGetAllPermissions<TData = Awaited<ReturnType<typeof getAllPermissions>>, TError = unknown>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAllPermissions>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getAllPermissions>>,
          TError,
          Awaited<ReturnType<typeof getAllPermissions>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useGetAllPermissions<TData = Awaited<ReturnType<typeof getAllPermissions>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAllPermissions>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getAllPermissions>>,
          TError,
          Awaited<ReturnType<typeof getAllPermissions>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useGetAllPermissions<TData = Awaited<ReturnType<typeof getAllPermissions>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAllPermissions>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }

export function useGetAllPermissions<TData = Awaited<ReturnType<typeof getAllPermissions>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAllPermissions>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {

  const queryOptions = getGetAllPermissionsQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




export const getPermission = (
    code: string,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {
      
      
      return customInstance<NubPermissionDTO>(
      {url: `/api/nub/permissions/${code}`, method: 'GET', signal
    },
      options);
    }
  



export const getGetPermissionInfiniteQueryKey = (code?: string,) => {
    return [
    'infinite', `/api/nub/permissions/${code}`
    ] as const;
    }

export const getGetPermissionQueryKey = (code?: string,) => {
    return [
    `/api/nub/permissions/${code}`
    ] as const;
    }

    
export const getGetPermissionInfiniteQueryOptions = <TData = InfiniteData<Awaited<ReturnType<typeof getPermission>>>, TError = unknown>(code: string, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getPermission>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetPermissionInfiniteQueryKey(code);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getPermission>>> = ({ signal }) => getPermission(code, requestOptions, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(code), ...queryOptions} as UseInfiniteQueryOptions<Awaited<ReturnType<typeof getPermission>>, TError, TData> & { queryKey: DataTag<QueryKey, TData> }
}

export type GetPermissionInfiniteQueryResult = NonNullable<Awaited<ReturnType<typeof getPermission>>>
export type GetPermissionInfiniteQueryError = unknown


export function useGetPermissionInfinite<TData = InfiniteData<Awaited<ReturnType<typeof getPermission>>>, TError = unknown>(
 code: string, options: { query:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getPermission>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getPermission>>,
          TError,
          Awaited<ReturnType<typeof getPermission>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useGetPermissionInfinite<TData = InfiniteData<Awaited<ReturnType<typeof getPermission>>>, TError = unknown>(
 code: string, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getPermission>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getPermission>>,
          TError,
          Awaited<ReturnType<typeof getPermission>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useGetPermissionInfinite<TData = InfiniteData<Awaited<ReturnType<typeof getPermission>>>, TError = unknown>(
 code: string, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getPermission>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }

export function useGetPermissionInfinite<TData = InfiniteData<Awaited<ReturnType<typeof getPermission>>>, TError = unknown>(
 code: string, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getPermission>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient 
 ):  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {

  const queryOptions = getGetPermissionInfiniteQueryOptions(code,options)

  const query = useInfiniteQuery(queryOptions, queryClient) as  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




export const getGetPermissionQueryOptions = <TData = Awaited<ReturnType<typeof getPermission>>, TError = unknown>(code: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getPermission>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetPermissionQueryKey(code);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getPermission>>> = ({ signal }) => getPermission(code, requestOptions, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(code), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getPermission>>, TError, TData> & { queryKey: DataTag<QueryKey, TData> }
}

export type GetPermissionQueryResult = NonNullable<Awaited<ReturnType<typeof getPermission>>>
export type GetPermissionQueryError = unknown


export function useGetPermission<TData = Awaited<ReturnType<typeof getPermission>>, TError = unknown>(
 code: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getPermission>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getPermission>>,
          TError,
          Awaited<ReturnType<typeof getPermission>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useGetPermission<TData = Awaited<ReturnType<typeof getPermission>>, TError = unknown>(
 code: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getPermission>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getPermission>>,
          TError,
          Awaited<ReturnType<typeof getPermission>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useGetPermission<TData = Awaited<ReturnType<typeof getPermission>>, TError = unknown>(
 code: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getPermission>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }

export function useGetPermission<TData = Awaited<ReturnType<typeof getPermission>>, TError = unknown>(
 code: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getPermission>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {

  const queryOptions = getGetPermissionQueryOptions(code,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




export const getPermissionsByCategory = (
    category: string,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {
      
      
      return customInstance<NubPermissionDTO[]>(
      {url: `/api/nub/permissions/category/${category}`, method: 'GET', signal
    },
      options);
    }
  



export const getGetPermissionsByCategoryInfiniteQueryKey = (category?: string,) => {
    return [
    'infinite', `/api/nub/permissions/category/${category}`
    ] as const;
    }

export const getGetPermissionsByCategoryQueryKey = (category?: string,) => {
    return [
    `/api/nub/permissions/category/${category}`
    ] as const;
    }

    
export const getGetPermissionsByCategoryInfiniteQueryOptions = <TData = InfiniteData<Awaited<ReturnType<typeof getPermissionsByCategory>>>, TError = unknown>(category: string, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getPermissionsByCategory>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetPermissionsByCategoryInfiniteQueryKey(category);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getPermissionsByCategory>>> = ({ signal }) => getPermissionsByCategory(category, requestOptions, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(category), ...queryOptions} as UseInfiniteQueryOptions<Awaited<ReturnType<typeof getPermissionsByCategory>>, TError, TData> & { queryKey: DataTag<QueryKey, TData> }
}

export type GetPermissionsByCategoryInfiniteQueryResult = NonNullable<Awaited<ReturnType<typeof getPermissionsByCategory>>>
export type GetPermissionsByCategoryInfiniteQueryError = unknown


export function useGetPermissionsByCategoryInfinite<TData = InfiniteData<Awaited<ReturnType<typeof getPermissionsByCategory>>>, TError = unknown>(
 category: string, options: { query:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getPermissionsByCategory>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getPermissionsByCategory>>,
          TError,
          Awaited<ReturnType<typeof getPermissionsByCategory>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useGetPermissionsByCategoryInfinite<TData = InfiniteData<Awaited<ReturnType<typeof getPermissionsByCategory>>>, TError = unknown>(
 category: string, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getPermissionsByCategory>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getPermissionsByCategory>>,
          TError,
          Awaited<ReturnType<typeof getPermissionsByCategory>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useGetPermissionsByCategoryInfinite<TData = InfiniteData<Awaited<ReturnType<typeof getPermissionsByCategory>>>, TError = unknown>(
 category: string, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getPermissionsByCategory>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }

export function useGetPermissionsByCategoryInfinite<TData = InfiniteData<Awaited<ReturnType<typeof getPermissionsByCategory>>>, TError = unknown>(
 category: string, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getPermissionsByCategory>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient 
 ):  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {

  const queryOptions = getGetPermissionsByCategoryInfiniteQueryOptions(category,options)

  const query = useInfiniteQuery(queryOptions, queryClient) as  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




export const getGetPermissionsByCategoryQueryOptions = <TData = Awaited<ReturnType<typeof getPermissionsByCategory>>, TError = unknown>(category: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getPermissionsByCategory>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetPermissionsByCategoryQueryKey(category);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getPermissionsByCategory>>> = ({ signal }) => getPermissionsByCategory(category, requestOptions, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(category), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getPermissionsByCategory>>, TError, TData> & { queryKey: DataTag<QueryKey, TData> }
}

export type GetPermissionsByCategoryQueryResult = NonNullable<Awaited<ReturnType<typeof getPermissionsByCategory>>>
export type GetPermissionsByCategoryQueryError = unknown


export function useGetPermissionsByCategory<TData = Awaited<ReturnType<typeof getPermissionsByCategory>>, TError = unknown>(
 category: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getPermissionsByCategory>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getPermissionsByCategory>>,
          TError,
          Awaited<ReturnType<typeof getPermissionsByCategory>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useGetPermissionsByCategory<TData = Awaited<ReturnType<typeof getPermissionsByCategory>>, TError = unknown>(
 category: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getPermissionsByCategory>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getPermissionsByCategory>>,
          TError,
          Awaited<ReturnType<typeof getPermissionsByCategory>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useGetPermissionsByCategory<TData = Awaited<ReturnType<typeof getPermissionsByCategory>>, TError = unknown>(
 category: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getPermissionsByCategory>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }

export function useGetPermissionsByCategory<TData = Awaited<ReturnType<typeof getPermissionsByCategory>>, TError = unknown>(
 category: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getPermissionsByCategory>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {

  const queryOptions = getGetPermissionsByCategoryQueryOptions(category,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




export const searchGroups = (
    params?: SearchGroupsParams,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {
      
      
      return customInstance<NubGroupDTO[]>(
      {url: `/api/nub/groups/search`, method: 'GET',
        params, signal
    },
      options);
    }
  



export const getSearchGroupsInfiniteQueryKey = (params?: SearchGroupsParams,) => {
    return [
    'infinite', `/api/nub/groups/search`, ...(params ? [params]: [])
    ] as const;
    }

export const getSearchGroupsQueryKey = (params?: SearchGroupsParams,) => {
    return [
    `/api/nub/groups/search`, ...(params ? [params]: [])
    ] as const;
    }

    
export const getSearchGroupsInfiniteQueryOptions = <TData = InfiniteData<Awaited<ReturnType<typeof searchGroups>>>, TError = unknown>(params?: SearchGroupsParams, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof searchGroups>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getSearchGroupsInfiniteQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof searchGroups>>> = ({ signal }) => searchGroups(params, requestOptions, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseInfiniteQueryOptions<Awaited<ReturnType<typeof searchGroups>>, TError, TData> & { queryKey: DataTag<QueryKey, TData> }
}

export type SearchGroupsInfiniteQueryResult = NonNullable<Awaited<ReturnType<typeof searchGroups>>>
export type SearchGroupsInfiniteQueryError = unknown


export function useSearchGroupsInfinite<TData = InfiniteData<Awaited<ReturnType<typeof searchGroups>>>, TError = unknown>(
 params: undefined |  SearchGroupsParams, options: { query:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof searchGroups>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof searchGroups>>,
          TError,
          Awaited<ReturnType<typeof searchGroups>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useSearchGroupsInfinite<TData = InfiniteData<Awaited<ReturnType<typeof searchGroups>>>, TError = unknown>(
 params?: SearchGroupsParams, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof searchGroups>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof searchGroups>>,
          TError,
          Awaited<ReturnType<typeof searchGroups>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useSearchGroupsInfinite<TData = InfiniteData<Awaited<ReturnType<typeof searchGroups>>>, TError = unknown>(
 params?: SearchGroupsParams, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof searchGroups>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }

export function useSearchGroupsInfinite<TData = InfiniteData<Awaited<ReturnType<typeof searchGroups>>>, TError = unknown>(
 params?: SearchGroupsParams, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof searchGroups>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient 
 ):  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {

  const queryOptions = getSearchGroupsInfiniteQueryOptions(params,options)

  const query = useInfiniteQuery(queryOptions, queryClient) as  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




export const getSearchGroupsQueryOptions = <TData = Awaited<ReturnType<typeof searchGroups>>, TError = unknown>(params?: SearchGroupsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof searchGroups>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getSearchGroupsQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof searchGroups>>> = ({ signal }) => searchGroups(params, requestOptions, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof searchGroups>>, TError, TData> & { queryKey: DataTag<QueryKey, TData> }
}

export type SearchGroupsQueryResult = NonNullable<Awaited<ReturnType<typeof searchGroups>>>
export type SearchGroupsQueryError = unknown


export function useSearchGroups<TData = Awaited<ReturnType<typeof searchGroups>>, TError = unknown>(
 params: undefined |  SearchGroupsParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof searchGroups>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof searchGroups>>,
          TError,
          Awaited<ReturnType<typeof searchGroups>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useSearchGroups<TData = Awaited<ReturnType<typeof searchGroups>>, TError = unknown>(
 params?: SearchGroupsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof searchGroups>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof searchGroups>>,
          TError,
          Awaited<ReturnType<typeof searchGroups>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useSearchGroups<TData = Awaited<ReturnType<typeof searchGroups>>, TError = unknown>(
 params?: SearchGroupsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof searchGroups>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }

export function useSearchGroups<TData = Awaited<ReturnType<typeof searchGroups>>, TError = unknown>(
 params?: SearchGroupsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof searchGroups>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {

  const queryOptions = getSearchGroupsQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




export const searchGroupByField = (
    field: string,
    value: string,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {
      
      
      return customInstance<NubGroupDTO[]>(
      {url: `/api/nub/groups/search/${field}/${value}`, method: 'GET', signal
    },
      options);
    }
  



export const getSearchGroupByFieldInfiniteQueryKey = (field?: string,
    value?: string,) => {
    return [
    'infinite', `/api/nub/groups/search/${field}/${value}`
    ] as const;
    }

export const getSearchGroupByFieldQueryKey = (field?: string,
    value?: string,) => {
    return [
    `/api/nub/groups/search/${field}/${value}`
    ] as const;
    }

    
export const getSearchGroupByFieldInfiniteQueryOptions = <TData = InfiniteData<Awaited<ReturnType<typeof searchGroupByField>>>, TError = unknown>(field: string,
    value: string, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof searchGroupByField>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getSearchGroupByFieldInfiniteQueryKey(field,value);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof searchGroupByField>>> = ({ signal }) => searchGroupByField(field,value, requestOptions, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(field && value), ...queryOptions} as UseInfiniteQueryOptions<Awaited<ReturnType<typeof searchGroupByField>>, TError, TData> & { queryKey: DataTag<QueryKey, TData> }
}

export type SearchGroupByFieldInfiniteQueryResult = NonNullable<Awaited<ReturnType<typeof searchGroupByField>>>
export type SearchGroupByFieldInfiniteQueryError = unknown


export function useSearchGroupByFieldInfinite<TData = InfiniteData<Awaited<ReturnType<typeof searchGroupByField>>>, TError = unknown>(
 field: string,
    value: string, options: { query:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof searchGroupByField>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof searchGroupByField>>,
          TError,
          Awaited<ReturnType<typeof searchGroupByField>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useSearchGroupByFieldInfinite<TData = InfiniteData<Awaited<ReturnType<typeof searchGroupByField>>>, TError = unknown>(
 field: string,
    value: string, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof searchGroupByField>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof searchGroupByField>>,
          TError,
          Awaited<ReturnType<typeof searchGroupByField>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useSearchGroupByFieldInfinite<TData = InfiniteData<Awaited<ReturnType<typeof searchGroupByField>>>, TError = unknown>(
 field: string,
    value: string, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof searchGroupByField>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }

export function useSearchGroupByFieldInfinite<TData = InfiniteData<Awaited<ReturnType<typeof searchGroupByField>>>, TError = unknown>(
 field: string,
    value: string, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof searchGroupByField>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient 
 ):  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {

  const queryOptions = getSearchGroupByFieldInfiniteQueryOptions(field,value,options)

  const query = useInfiniteQuery(queryOptions, queryClient) as  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




export const getSearchGroupByFieldQueryOptions = <TData = Awaited<ReturnType<typeof searchGroupByField>>, TError = unknown>(field: string,
    value: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof searchGroupByField>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getSearchGroupByFieldQueryKey(field,value);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof searchGroupByField>>> = ({ signal }) => searchGroupByField(field,value, requestOptions, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(field && value), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof searchGroupByField>>, TError, TData> & { queryKey: DataTag<QueryKey, TData> }
}

export type SearchGroupByFieldQueryResult = NonNullable<Awaited<ReturnType<typeof searchGroupByField>>>
export type SearchGroupByFieldQueryError = unknown


export function useSearchGroupByField<TData = Awaited<ReturnType<typeof searchGroupByField>>, TError = unknown>(
 field: string,
    value: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof searchGroupByField>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof searchGroupByField>>,
          TError,
          Awaited<ReturnType<typeof searchGroupByField>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useSearchGroupByField<TData = Awaited<ReturnType<typeof searchGroupByField>>, TError = unknown>(
 field: string,
    value: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof searchGroupByField>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof searchGroupByField>>,
          TError,
          Awaited<ReturnType<typeof searchGroupByField>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useSearchGroupByField<TData = Awaited<ReturnType<typeof searchGroupByField>>, TError = unknown>(
 field: string,
    value: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof searchGroupByField>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }

export function useSearchGroupByField<TData = Awaited<ReturnType<typeof searchGroupByField>>, TError = unknown>(
 field: string,
    value: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof searchGroupByField>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {

  const queryOptions = getSearchGroupByFieldQueryOptions(field,value,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




export const getPrimaryGroups = (
    
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {
      
      
      return customInstance<NubGroupDTO[]>(
      {url: `/api/nub/groups/primary`, method: 'GET', signal
    },
      options);
    }
  



export const getGetPrimaryGroupsInfiniteQueryKey = () => {
    return [
    'infinite', `/api/nub/groups/primary`
    ] as const;
    }

export const getGetPrimaryGroupsQueryKey = () => {
    return [
    `/api/nub/groups/primary`
    ] as const;
    }

    
export const getGetPrimaryGroupsInfiniteQueryOptions = <TData = InfiniteData<Awaited<ReturnType<typeof getPrimaryGroups>>>, TError = unknown>( options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getPrimaryGroups>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetPrimaryGroupsInfiniteQueryKey();

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getPrimaryGroups>>> = ({ signal }) => getPrimaryGroups(requestOptions, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseInfiniteQueryOptions<Awaited<ReturnType<typeof getPrimaryGroups>>, TError, TData> & { queryKey: DataTag<QueryKey, TData> }
}

export type GetPrimaryGroupsInfiniteQueryResult = NonNullable<Awaited<ReturnType<typeof getPrimaryGroups>>>
export type GetPrimaryGroupsInfiniteQueryError = unknown


export function useGetPrimaryGroupsInfinite<TData = InfiniteData<Awaited<ReturnType<typeof getPrimaryGroups>>>, TError = unknown>(
  options: { query:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getPrimaryGroups>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getPrimaryGroups>>,
          TError,
          Awaited<ReturnType<typeof getPrimaryGroups>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useGetPrimaryGroupsInfinite<TData = InfiniteData<Awaited<ReturnType<typeof getPrimaryGroups>>>, TError = unknown>(
  options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getPrimaryGroups>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getPrimaryGroups>>,
          TError,
          Awaited<ReturnType<typeof getPrimaryGroups>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useGetPrimaryGroupsInfinite<TData = InfiniteData<Awaited<ReturnType<typeof getPrimaryGroups>>>, TError = unknown>(
  options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getPrimaryGroups>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }

export function useGetPrimaryGroupsInfinite<TData = InfiniteData<Awaited<ReturnType<typeof getPrimaryGroups>>>, TError = unknown>(
  options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getPrimaryGroups>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient 
 ):  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {

  const queryOptions = getGetPrimaryGroupsInfiniteQueryOptions(options)

  const query = useInfiniteQuery(queryOptions, queryClient) as  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




export const getGetPrimaryGroupsQueryOptions = <TData = Awaited<ReturnType<typeof getPrimaryGroups>>, TError = unknown>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getPrimaryGroups>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetPrimaryGroupsQueryKey();

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getPrimaryGroups>>> = ({ signal }) => getPrimaryGroups(requestOptions, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getPrimaryGroups>>, TError, TData> & { queryKey: DataTag<QueryKey, TData> }
}

export type GetPrimaryGroupsQueryResult = NonNullable<Awaited<ReturnType<typeof getPrimaryGroups>>>
export type GetPrimaryGroupsQueryError = unknown


export function useGetPrimaryGroups<TData = Awaited<ReturnType<typeof getPrimaryGroups>>, TError = unknown>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getPrimaryGroups>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getPrimaryGroups>>,
          TError,
          Awaited<ReturnType<typeof getPrimaryGroups>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useGetPrimaryGroups<TData = Awaited<ReturnType<typeof getPrimaryGroups>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getPrimaryGroups>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getPrimaryGroups>>,
          TError,
          Awaited<ReturnType<typeof getPrimaryGroups>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useGetPrimaryGroups<TData = Awaited<ReturnType<typeof getPrimaryGroups>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getPrimaryGroups>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }

export function useGetPrimaryGroups<TData = Awaited<ReturnType<typeof getPrimaryGroups>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getPrimaryGroups>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {

  const queryOptions = getGetPrimaryGroupsQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




